import React from 'react'
import AdnCard from '../common/adnCard/AdnCard'
import AdnPageTitle from '../common/adnPageTitle/AdnPageTitle'
import AdnTable from '../common/adnTable/AdnTable'
import { Col, Modal, Row, Space, Form } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import AdnInput from '../common/adnInput/AdnInput';
import AdnAddButton from '../common/adnAddButton/AdnAddButton';
import { NameValidation } from './TechnologyValidations';
import adnYesNoModal from '../common/adnYesNoModal/AdnYesNoModal';

function TechnologyPageForm({ loading, technologyData, visible, setVisible, event, submitTechnology, setEvent, setTechnologyHandler, deleteRecord }) {
    const [form] = Form.useForm();
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            width: '30%',
            editable: true,
            sorter: (a, b) => a.name.localeCompare(b.name),
        },

        {
            title: "Actions",
            key: "action",
            render: (record) => (
                <Space size="middle">
                    <EditOutlined
                        style={{ color: "black" }}
                        onClick={() => {
                            setEvent("edit")
                            setVisible(true);
                            form.setFieldsValue(record);
                            setTechnologyHandler(record);
                        }}
                    />

                    <DeleteOutlined
                        style={{ color: "red" }}
                        onClick={() => {
                            adnYesNoModal(() => deleteRecord(record.id))
                        }}
                    />
                </Space>
            ),
            width: "10%",
        },
    ];

    return <>
        <AdnPageTitle title={"Technologies "} />
        <AdnCard loading={loading}>

            <AdnAddButton handleClick={() => { setEvent("add"); setVisible(true); form.setFieldsValue({ name: "" }); }} />

            <Row>
                <Col span={24}>
                    <AdnTable data={technologyData} columns={columns} pagination={false} />
                </Col>
            </Row>

        </AdnCard>

        <Modal
            title={(event == "add") ? "New Technology" : "Edit Technoogy"}
            open={visible}
            onOk={form.submit}
            cancelText={"Back"}
            okText={"Save"}
            onCancel={() => { setVisible(false); }}>

            <Form form={form} name="form_in_modal" layout="vertical" onFinish={submitTechnology}>

                <AdnInput name={"name"} label={"Name"} placeholder={"Insert the name"} rules={NameValidation} />

            </Form>

        </Modal>
    </>

}

export default TechnologyPageForm